
Checkout.Payment = function(checkout) {
	var payment = this;

	this.saved = true;

	this.summary = false;
	this.totals = false;

	this.methods = {};
	this.balanceMethods = [];
	this.methodRequired = true;

	this.optionToMethod = {
		'creditcard': Checkout.Payment.CreditCard,
		'storedcreditcard': Checkout.Payment.StoredCreditCard,
		'storedbtpaypal': Checkout.Payment.StoredCreditCard,
		'paypal': Checkout.Payment.PayPal,
		'wiretransfer': Checkout.Payment.WireTransfer,
		'priorauth': Checkout.Payment.PriorAuth,
		'paypalrequest': Checkout.Payment.PayPalRequest,
		'onaccount': Checkout.Payment.OnAccount
	};

	this.$wrap = $('#paymentoptionswrapper');
	this.$anchor = $('a[name=payment]');
	this.$error = $('#payment-error');
	this.$errorMsg = this.$error.find('.msg-text');
	this.$loadingOverlay = $('#payment-loading-overlay');
	this.$loadingMsg = this.$loadingOverlay.find('.msg-text');

	this.$cShopping = this.$wrap.find('.cshopping');
	this.$showEmailCart = this.$wrap.find('#showEmailCart');
	this.$methodWrap = $('#payment-selector');
	this.$methodError = $('#payment-method-error');
	this.$methodErrorMsg = this.$methodError.find('.msg-text');
	this.$methodSelect = $('#payment-method-select');
	this.$methodSelectWrap = $('#payment-method-select-wrap');
	this.$methodSelectDisabled = $('#payment-method-select-disabled');
	this.$methodSelectAdd = $('#payment-method-add-another select');
	this.$methodContainer = $('#payment-method-container');
	this.creditCardWrap = false;

    this.bt = false;

	this.init = function() {
		payment.listen();

		payment.summary = new Checkout.Payment.Summary(checkout, payment);
		payment.totals = new Checkout.Payment.Totals(checkout, payment);

		payment.balanceMethods.push(new Checkout.Payment.InStore(checkout, payment));
		payment.balanceMethods.push(new Checkout.Payment.Rewards(checkout, payment));
		payment.balanceMethods.push(new Checkout.Payment.GiftCard(checkout, payment));

		if (checkout.config.paypalError) {
			payment.error(checkout.paypalErrorMsg);
			checkout.config.paypalError = 0;
		}
	};

	this.listen = function() {
		payment.$methodSelect.change(function() {
			payment.changeMethod(true);
		});

		payment.$methodSelectAdd.change(function() {
			payment.addMethod(payment.$methodSelectAdd.val(), 0.00, true);
			payment.$methodSelectAdd.val('');
		});

		$('.payment-method-remove').click(function() {
			payment.removeMethod(false, $(this), true);
			payment.setMethodSessionData();
		});

		$('.payment-method-amount input')
			.bind('input propertychange', function() {
				payment.changeMethodAmt($(this), false);
			})
			.change(function() {
				payment.changeMethodAmt($(this), true);
			});

		$('.payment-method input, .payment-method select, #payment-method-select').focus(function() {
			payment.removeFieldError($(this));
		});

		// listen for cart content changes

		checkout.cart.$wrap.on('loading', function(e, loadingMsg) {
			payment.loading(loadingMsg);
		});

		checkout.cart.$wrap.on('loadDone', function(e, stepChanged) {

			payment.loading(false);

			if (
				checkout.session.get('step') == 'billship'
				|| checkout.session.get('step') == 'payment'
			) {

				if (stepChanged == 'cart')
					payment.summary.buildContent();

				payment.totals.buildContent();

			}

			payment.toggleMethodRequired();

			payment.reApplyBalances();

		});

		checkout.cart.$wrap.on('loadFail', function() {
			payment.hide();
		});
	};

	this.buildContent = function(addMethod) {
		if (checkout.user) {
			var $options = payment.$methodSelectDisabled
				.children()
				.remove();

			if ($options.length) {
				payment.$methodSelect.append($options.clone());
				payment.$methodSelectAdd.append($options.clone());
			}
		}

        var storedPayments = checkout.session.get('storedPayments');

        if (storedPayments.length) {
            var options = $.map(storedPayments, function(storedPayment) {
                var optionValue = storedPayment.method;
                var optionLabel;
                if (creditCardTypes[storedPayment.cardType]) 
                        optionLabel = (
                            creditCardTypes[storedPayment.cardType].label
                            + ' ending in '
                            + storedPayment.cardLast4
                        );
                else if (storedPayment.cardType == 'btpaypal')
                    optionLabel = (
                        'PayPal: ' + storedPayment.paypalEmail 
                    );
                return '<option value="' + optionValue+'">' + optionLabel + '</option>';
            }).join("\n");

            payment.$methodSelect.find('option[value="creditcard"]')
                .text('Credit Card (New)')
                .before($(options));

            payment.$methodSelectAdd.find('option[value="creditcard"]')
                .text('Credit Card (New)')
                .before($(options));

            if (checkout.user) { // remove duplicate stored payments when sales logs in as a customer
                var found = [];
                $('#payment-method-select option').each(function() {
                    if(this.value && ($.inArray(this.value, found) != -1)) {
                         $(this).remove();
                    }
                    found.push(this.value);
                });

                found = [];
                $('#payment-method-add-another select option').each(function() {
                    if(this.value && ($.inArray(this.value, found) != -1)) {
                         $(this).remove();
                    }
                    found.push(this.value);
                });
            }
        }

		payment.summary.buildContent();
		payment.totals.buildContent();

		$.each(payment.balanceMethods, function(i, method) {
			if (method.buildContent)
				method.buildContent();
		});

		payment.buildMethods();

		payment.$wrap.show();
        payment.toggleAddMultiDisplayOptions();

		checkout.cart.totals.update('payment');
	};

    this.toggleAddMultiDisplayOptions = function() {

        var $options = payment.$methodSelectAdd.find('option');

        $options.show();

        $.each(payment.methods, function(methodKey, method) {
            if (method.noDisplayCombo && Array.isArray(method.noDisplayCombo) && method.noDisplayCombo.length > 0) {
				method.noDisplayCombo.forEach( function (currentValue, index, array) {
                	$options.filter('[value="' + currentValue + '"]').hide();
                	$options.filter('[value^="' + currentValue + '-"]').hide();
				});
            }
        });
    };

	this.buildMethods = function() {
		var methodData = checkout.session.get('paymentMethods');

		if ( methodData && methodData.length ) {
			payment.$methodSelect.val(methodData[0].method);

			$.each(methodData, function(i, data) {
				payment.addMethod(
					data.method,
					(parseFloat(data.amount) || 0),
					false
				);
			});
		} else {
			payment.addMethod(
				payment.$methodSelect.val(),
				(parseFloat(checkout.cart.totals.values.remaining) || 0),
				false
			);
		}
	};

	this.hide = function() {
		payment.$wrap.hide();
		payment.methods = {};
		payment.$methodContainer.empty();
		payment.creditCardWrap = false;
	};

	this.getMethodsByType = function(methodType) {
		var methods = [];

		payment.$methodContainer.find('div[data-method='+methodType+']')
			.each(function(i, methodWrap) {
				var methodKey = $(methodWrap).data('methodKey');

				if (payment.methods[methodKey])
					methods.push(payment.methods[methodKey]);
			});

		return methods;
	};

	this.changeMethod = function(updateTotals) {
		payment.methodError(false);

		for (var methodKey in payment.methods)
			payment.removeMethod(methodKey, false, false);

		payment.addMethod(
			payment.$methodSelect.val(),
			(parseFloat(checkout.cart.totals.values.remaining) || 0),
			false
		);

		payment.setMethodSessionData();
        payment.toggleAddMultiDisplayOptions();

		if (updateTotals)
			checkout.cart.totals.update('payment');
	};

	this.addMethod = function(methodOption, amount, updateTotals) {
		payment.methodError(false);

		if (!methodOption)
			return;

		for (var methodKey in payment.methods)
			if (
				'allowMulti' in payment.methods[methodKey]
				&& !payment.methods[methodKey].allowMulti
			)
				return payment.methodError(payment.methods[methodKey].multiError);

        var methodOptionParts = methodOption.split('-');

        var methodValue = methodOptionParts[0];
        var storedPaymentID = methodOptionParts[1];
        var storedPayment;

        if (storedPaymentID) {
            $.each(checkout.session.get('storedPayments'), function(i, otherStoredPayment) {
                if (methodOption == otherStoredPayment.method) {
                    storedPayment = otherStoredPayment;
                }
            });
        }
 
		if (!payment.optionToMethod[ methodValue ] ) {
			return payment.methodError( 'Invalid Payment Method ('+methodValue+')');
		}

		var method = new payment.optionToMethod[methodValue](checkout, payment, storedPayment),
			methodKey = (new Date()).getTime(),
			$container = payment.$methodContainer;

		if (method.addError)
			return payment.methodError(method.addError);

		if (method.getContainer)
			$container = method.getContainer();

		method.$wrap.data('methodKey', methodKey);
		method.$amtInput = (method.$amtInput || method.$wrap.find('.payment-method-amount input'));

		if (!method.$amtInput.attr('disabled'))
			payment.setMethodAmt(method, amount);

		payment.methods[methodKey] = method;

		$container
			.append(method.$wrap)
			.show();

		if (Object.keys(payment.methods).length > 1) {
			payment.$methodSelectWrap.hide();
			payment.removeFieldError(payment.$methodSelect);
			payment.$wrap.find('.payment-method-amount, .payment-method-label').show();
		}

        payment.toggleAddMultiDisplayOptions();

		if (updateTotals)
			checkout.cart.totals.update('payment');
	};

	this.removeMethod = function(methodKey, $button, updateTotals) {
		methodKey = methodKey || $button.parents('.payment-method').first().data('methodKey');

		var method = payment.methods[methodKey];

		delete(payment.methods[methodKey]);

		method.$wrap.remove();

		if (method.afterRemoved)
			method.afterRemoved();

		var methodKeys = Object.keys(payment.methods);

		if (methodKeys.length <= 1) {

			if (methodKeys.length == 1) {

                var remainingMethod = payment.methods[methodKeys[0]],
                selectMethodValue = remainingMethod.$wrap.attr('data-method');

                if (remainingMethod.getStoredPaymentType) {
                    selectMethodValue = remainingMethod.getStoredPaymentType();
                }
                if (remainingMethod.getStoredPaymentID) {
                    selectMethodValue += ('-' + remainingMethod.getStoredPaymentID());
                }
				payment.$methodSelect.val(selectMethodValue);

				payment.setMethodAmt(
					remainingMethod,
					(parseFloat(checkout.cart.totals.values.remaining) || 0)
				);

			}

			payment.$methodSelectWrap.show();

			payment.$wrap.find('.payment-method-amount, .payment-method-label').hide();
		}

        payment.toggleAddMultiDisplayOptions();

		if (updateTotals)
			checkout.cart.totals.update('payment');
	};

	this.changeMethodAmt = function($input, blurred) {
		var thisMethodKey = $input.parents('.payment-method').first().data('methodKey'),
			thisMethod = payment.methods[thisMethodKey],
			thisMethodAmt = 0.00,
			thisMethodAmtEnabled = true,
			amounts = {},
			methodTotal = 0.00,
			disabledTotal = 0.00,
			remainingBalance = (parseFloat(checkout.cart.totals.values.remaining) || 0);

		if (thisMethod.$amtInput.attr('disabled'))
			thisMethodAmtEnabled = false;

		for (var methodKey in payment.methods) {
			var method = payment.methods[methodKey],
				amount = payment.getMethodAmt(method);

			amounts[methodKey] = amount;

			if (method.$amtInput.attr('disabled'))
				disabledTotal += amount;

		}

		for (var methodKey in amounts) {

			if (thisMethodKey == methodKey)
				thisMethodAmt = amounts[methodKey];

			methodTotal += amounts[methodKey];
		}

		if (methodTotal > remainingBalance) {
			var totalReduceAmt = (methodTotal - remainingBalance);

			for (var methodKey in payment.methods) {
				var method = payment.methods[methodKey];

				if (
					thisMethodKey == methodKey
					|| method.$amtInput.attr('disabled')
				)
					continue;

				var newAmount = (amounts[methodKey] - totalReduceAmt);

				if (newAmount <= 0)
					newAmount = 0;

				payment.setMethodAmt(method, newAmount);

				totalReduceAmt -= (amounts[methodKey] - newAmount);

				if (totalReduceAmt <= 0)
					break;
			}
		}

		if (blurred) {

			if (
				thisMethodAmtEnabled
				|| thisMethodAmt > remainingBalance
			) {

				if (!thisMethodAmtEnabled)
					thisMethodAmt = (remainingBalance - (disabledTotal - thisMethodAmt));
				else if (thisMethodAmt > (remainingBalance - disabledTotal))
					thisMethodAmt = (remainingBalance - disabledTotal);

				payment.setMethodAmt(thisMethod, thisMethodAmt);
			}

			payment.setMethodSessionData();
		}

		checkout.cart.totals.buildPaymentMethods();
		payment.totals.buildPaymentMethods();

	};

	this.getMethodAmt = function(method) {
		return parseFloat((parseFloat(method.$amtInput.val()) || 0).toMoney());
	};

	this.setMethodAmt = function(method, amount) {
		var origAmt = payment.getMethodAmt(method);

		if (amount < 0)
			amount = 0.00;

		method.$amtInput.val(amount.toMoney());

		if (
			method.afterChangeAmt
			&& origAmt != amount
		)
			method.afterChangeAmt(amount);
	};

	this.validateMethod = function(method) {
		var valid = true;

		if (payment.getMethodAmt(method) <= 0) {
			payment.fieldError(method.$amtInput, 'Payment Amount Required');
			valid = false;
		}

		if (
			method.validate
			&& !method.validate()
		)
			valid = false;

		return valid;
	};

	this.toggleMethodRequired = function() {
		var remainingBalance = (parseFloat(checkout.cart.totals.values.remaining) || 0);

		if (remainingBalance > 0) {
			var methodKeys = Object.keys(payment.methods);

			payment.methodRequired = true;

			if (methodKeys.length == 1)
				payment.setMethodAmt(payment.methods[methodKeys[0]], remainingBalance);
			else if (methodKeys.length)
				payment.changeMethodAmt(payment.methods[methodKeys[0]].$amtInput, true);

			payment.$methodWrap.show();

			$.each(payment.balanceMethods, function(i, method) {
				method.unlock();
			});

            payment.setMethodSessionData();
            checkout.session.save();

		} else {

			payment.methodRequired = false;

			payment.$methodWrap.hide();
			payment.$methodWrap.find('input').not('.payment-method-amount input').val('');

			$.each(payment.balanceMethods, function(i, method) {
				method.lock();
			});

			payment.setMethodSessionData({
				'paymentMethods': [
					{
						'method': 'balance',
						'amount': '0.00'
					}
				]
			});

		}
	};

	this.changeFees = function(method, fee, updateTotals) {
		var fees = checkout.cart.totals.values.fees;

		fee = parseFloat(fee) || 0;

		// No Change
		if ((fees[method.label] || 0) == fee)
			return;

		if (fee)
			fees[method.label] = fee;
		else
			delete(fees[method.label]);

		if (updateTotals)
			checkout.cart.totals.update('payment');

	};

	this.changeBalanceMethod = function(method, balance, userEvent) {
		var balances = checkout.cart.totals.values.balances;

		balance = parseFloat(balance) || 0;

		// No Change
		if ((balances[method.label] || 0) == balance)
			return;

		if (balance)
			balances[method.label] = balance;
		else
			delete(balances[method.label]);

		if (userEvent)
			payment.reApplyBalances(true);

	};

	this.reApplyBalances = function(forceUpdateTotals) {
		var usedBalanceTotal = 0;

		$.each(payment.balanceMethods, function(i, method) {
			method.reApplyBalance();
			usedBalanceTotal += (checkout.cart.totals.values.balances[method.label] || 0);
		});

		// If force update or used balance amount has changed / needs updated
		if (
			forceUpdateTotals
			||
			(
				parseFloat((parseFloat(checkout.cart.totals.values.total) - usedBalanceTotal).toMoney()) // calculated remaining balance
				!= parseFloat(parseFloat(checkout.cart.totals.values.remaining).toMoney()) // current remaining balance
			)
		)
			checkout.cart.totals.update('payment');
		else {
			checkout.cart.totals.buildPaymentMethods();
			payment.totals.buildPaymentMethods();
		}
	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			payment.$loadingMsg.html(loadingMsg);
			payment.$loadingOverlay.show();
			checkout.alignMiddle(payment.$loadingOverlay.find('.msg'), payment.$loadingOverlay);
		} else
			payment.$loadingOverlay.hide();
	};

    this.prepareData = function( callback ) {
        var preparingData = 1;
        var dataPrepared = function() {
            preparingData --;
            if( preparingData == 0 ) {
                callback();
            }
        };

        if( payment.methodRequired ) {
            $.each( payment.methods, function( methodKey, method ) {
                if( method.prepareData ) {
                    preparingData ++;
                    method.prepareData( dataPrepared );
                }
            } );
        }

        // if there was nothing to prepare, we still want the callback to happen
        dataPrepared();
    };

	this.getData = function(fullData) {
		var methodData = [];

		if (payment.methodRequired)
			$.each(payment.methods, function(methodKey, method) {
				methodData.push(payment.getMethodData(method, fullData));
			});

		return methodData;
	};

	this.getMethodData = function(method, fullData) {
		var data = ((fullData) ? method.getData() : {});

		data.method = method.$wrap.attr('data-method');
		data.amount = payment.getMethodAmt(method).toMoney();

		if (method.getStoredPaymentType) 
			data.method = method.getStoredPaymentType();
        if (method.getStoredPaymentID)
            data.method += ('-' + method.getStoredPaymentID());

		return data;
	};

	this.setMethodSessionData = function(newMethodData) {
		newMethodData = newMethodData || payment.getMethodSessionData();

		if (payment.methodSessionDataChanged(newMethodData)) {

			checkout.session.set({
				'paymentMethods': newMethodData
			});

			payment.saved = false;
		}

	};

	this.getMethodSessionData = function() {
		var methodData = [];

		for (var methodKey in payment.methods)
			methodData.push(payment.getMethodData(payment.methods[methodKey], false));

		return methodData;
	};

	this.methodSessionDataChanged = function(newMethodData) {
		var methodData = checkout.session.get('paymentMethods'),
			maxLength = newMethodData.length;

		if (!methodData)
			return true;

		if (methodData.length > maxLength)
			maxLength = methodData.length;

		for (var i=0; i<maxLength; i++) {
			var newData = newMethodData[i],
				data = methodData[i];

			if (
				!data
				|| !newData
				|| data.method != newData.method
				|| data.amount != newData.amount
			)
				return true;
		}

		return false;
	};

	this.validate = function() {
		var valid = true,
			methodTotal = 0.00,
			total = (parseFloat(checkout.cart.totals.values.total) || 0),
			remainingBalance = (parseFloat(checkout.cart.totals.values.remaining) || 0);

		payment.removeErrors();

		if (!payment.methodRequired)
			return true;

		for (var methodKey in payment.methods) {
			var method = payment.methods[methodKey];

			methodTotal += payment.getMethodAmt(method);

			if (!payment.validateMethod(method))
				valid = false;
		}

		if (methodTotal.toMoney() != remainingBalance.toMoney()) {
			payment.methodAmountsInvalid((remainingBalance - methodTotal), (methodTotal - remainingBalance));
			valid = false;
		}

		return valid;
	};

	this.methodAmountsInvalid = function(increaseAmt, decreaseAmt) {
		var total = (parseFloat(checkout.cart.totals.values.total) || 0),
			remainingBalance = (parseFloat(checkout.cart.totals.values.remaining) || 0);

		payment.error(
			'Payment Amounts must add up to '
			+ (
				(remainingBalance == total) ?
					'Order Total'
					: 'Remaining Balance'
			)
			+ '. '
			+ (
				(increaseAmt > 0) ?
					'Increase of $' + increaseAmt.toMoney()
					: 'Decrease of $' + decreaseAmt.toMoney()
			)
			+ ' required.'
		);
	};

	this.methodInvalid = function(idx, errorMsg) {
		var method = payment.idxToMethod(idx),
			$field = method.$amtInput;

		if (!method.$amtInput.filter(':visible').length)
			$field = payment.$methodSelect;

		if (method)
			payment.fieldError($field, errorMsg);
	};

	this.methodAmountInvalid = function(idx) {
		var method = payment.idxToMethod(idx);

		if (method)
			payment.fieldError(method.$amtInput, 'Payment Amount Required');
	};

	this.methodFieldErrors = function(idx, fieldErrors) {
		var method = payment.idxToMethod(idx);

		if (
			method
			&& method.fieldErrors
		)
			method.fieldErrors(fieldErrors);
	};

	this.idxToMethod = function(idx) {
		var $wrap = payment.$wrap.find('.payment-method:eq('+idx+')');

		if (!$wrap.length)
			return false;

		return payment.methods[$wrap.data('methodKey')];
	};

	this.fieldError = function($field, errorMsg) {
		var enabled = true;

        if ( ! $field ) return;

		if ($field.attr('disabled')) {
			enabled = false;
			errorMsg += '<button type="button" class="btn btn-link button-remove"><i class="icon-remove icon-white"></i></button>'
		}

		$field
			.addClass('field-error')
			.tooltip({
				title: errorMsg,
				html: true,
				trigger: 'manual',
				container: 'body',
			})
			.tooltip('show');

		if (!enabled) {
			var $tip = $field.data('tooltip').$tip;

			$tip.find('.tooltip-inner')
				.css({
					'position': 'relative',
					'padding-right': 35
				});

			$tip.find('.button-remove')
				.css({
					'position': 'absolute',
					'top': 0,
					'right': 0
				})
				.click(function() {
					payment.removeFieldError($field);
				});

		}
	};

	this.removeFieldError = function($field) {
		$field
			.removeClass('field-error')
			.tooltip('dispose');
	};

	this.removeErrors = function() {
		payment.removeFieldErrors();
		payment.error(false);
	};

	this.removeFieldErrors = function() {
		payment.$wrap.find('.field-error')
			.removeClass('field-error')
			.tooltip('dispose');
	};

	this.error = function(errorMsg) {


		if (errorMsg) {
			var errorMsgHTML = errorMsg.replace(/\n/g, '<br />'),
				currentMsg = payment.$errorMsg.html();

			if (currentMsg)
				payment.$errorMsg.html(currentMsg + '<br />' + errorMsgHTML);
			else
				payment.$errorMsg.html(errorMsgHTML);

			payment.$error.show();

		} else {
			payment.$error.hide();
			payment.$errorMsg.html('');
		}
	}

	this.methodError = function(errorMsg) {
		if (errorMsg) {
			payment.$methodErrorMsg.html(errorMsg);
			payment.$methodError.show();
		} else {
			payment.$methodError.hide();
			payment.$methodErrorMsg.html('');
		}
	};

    this.getBT = function( callback ) {
        if( this.bt ) callback();

        if ( ! window.braintree ) return console.error( "Missing BT interface" );
    
        window.braintree.client.create(
            {
                'authorization' : checkout.config.braintreeClientToken,
            },
            function( err, bt ) {
                if( err ) return console.error( "BT client failed", err );

                this.bt = bt;
                callback();
            }
        );
    };

    this.init();
};

